import { render, staticRenderFns } from "./AboutMediaBlock.vue?vue&type=template&id=5572eaaa&scoped=true&"
import script from "./AboutMediaBlock.vue?vue&type=script&lang=js&"
export * from "./AboutMediaBlock.vue?vue&type=script&lang=js&"
import style0 from "./AboutMediaBlock.vue?vue&type=style&index=0&id=5572eaaa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5572eaaa",
  null
  
)

export default component.exports